import { Directive, Input } from '@angular/core';
import {
    AbstractControl,
    NG_VALIDATORS,
    Validator,
    ValidatorFn
} from '@angular/forms';
import { DateUtilService, moment_duration } from '../utilities/date.util.service';

/** A hero's name can't match the given regular expression */
export function FieldValidator(nameRe: RegExp): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const result = nameRe.test(control.value);
        return result ? null : { FieldValidator: { value: control.value } };
    };
}

@Directive({
    selector: '[FieldValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: FieldValidatorDirective,
            multi: true
        }
    ]
})
export class FieldValidatorDirective implements Validator {
    @Input('FieldValidator') value: string;

    constructor(private readonly dateUtil: DateUtilService) { }

    validate(control: AbstractControl): { [key: string]: any } | null {
        //Validate email
        if (this.value == 'email') {
            var re = /\S+@\S+\.\S+/;
            return control.value
                ? FieldValidator(new RegExp(re))(control)
                : null;
        }

        //Validate password
        if (this.value == 'password') {
            var re = /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,}$/;
            return control.value
                ? FieldValidator(new RegExp(re))(control)
                : null;
        }

        //Validate Date of Birth
        if (this.value == 'Dob') {
            if (!control.value)
                return null;
            const diff = this.dateUtil.diff(new Date(control.value), new Date(), moment_duration.years);
            if (diff < 18)
                return { FieldValidator: { value: control.value } };
            return null;
        }

        return this.value != control.value
            ? { FieldValidator: { value: control.value } }
            : null;
    }
}
